import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchBrandProfileById = (params) => async (dispatch) => {
	try {
		dispatch(openLoader());
		const { data } = await ApiClient.GET('getBrandInfo', params);
		dispatch({
			type: Types.FETCH_BRAND_PROFILE_BY_BRAND_ID,
			payload: data
		});
		dispatch(closeLoader());
	} catch (err) {
		dispatch(openLoader());
		toastError(err.response.data.message);
	}
};

export const fetchPriceRangeTableDataById = (brandId) => async (dispatch) => {
	try {
		dispatch(openLoader());
		const { data } = await ApiClient.GET('brandAction', `${brandId}/price-range`);
		dispatch({
			type: Types.FETCH_PRICE_RANGE_TABLE_DATA_BY_BRAND_ID,
			payload: data
		});
		dispatch(closeLoader());
	} catch (err) {
		dispatch(openLoader());
		toastError(err.response.data.message);
	}
};

export const fetchProfitMarginTableDataById = (brandId) => async (dispatch) => {
	try {
		dispatch(openLoader());
		const { data } = await ApiClient.GET('brandAction', `${brandId}/profit-margin`);
		dispatch({
			type: Types.FETCH_PROFIT_MARGIN_TABLE_DATA_BY_BRAND_ID,
			payload: data
		});
		dispatch(closeLoader());
	} catch (err) {
		dispatch(openLoader());
		toastError(err.response.data.message);
	}
};
